import {useEffect, useRef, useState} from 'react';

//import * as LogFunctions from './../Helpers/LogFunctions';
import {
    ActivityIndicator,
    CCText,
    View
} from '../../../custom-packages/react-native-components-in-react/react-native-components-in-react';

import AppConfig from '../../../AppConfig';


import {ThemeButton} from '../../../custom-packages/react-button-package/ButtonPackage';
import {FormModal} from '../../../custom-packages/react-chocoforms/legacy/ChocoForm';
import TMenuScreen from '../../public/Menu/Translations/TMenuScreen';
import MenuItem from '../../../components/admin/Menu/MenuItem';
import {GetAuthObject} from "../../../authentication/AuthFunctions";
import Menu from "../../../models/menu/Menu";
import ChocoForm from "../../../custom-packages/react-chocoforms/typescript/models/ChocoForm";
import ChocoControl from "../../../custom-packages/react-chocoforms/typescript/models/ChocoControl";
import ChocoValidation from "../../../custom-packages/react-chocoforms/typescript/models/ChocoValidation";

const MenuScreen = (props) => {
    const timerRef = useRef(null);
    const auth = GetAuthObject()

    let offset = 0;
    const limit = 10;
    let stopFetching = false;
    let currentlyFetching = false;

    const [filterActive] = useState(true);
    const [hideLoadButton, setHideLoadButton] = useState(false);
    const [loading, setLoading] = useState(true);
    const [search] = useState('');
    const [menus, setMenus] = useState<Array<Menu>>([]);
    const [form, setForm] = useState<ChocoForm>(new ChocoForm({
        men_name: new ChocoControl({
            elementType: 'input',
            elementConfig: {
                placeholder: TMenuScreen[AppConfig.lang].NAME,
                autoCapitalize: 'words'
            },
            label: TMenuScreen[AppConfig.lang].NAME + '*',
            value: '',
            errorMessage: '',
            validation: new ChocoValidation({
                required: true
            }),
        }),
    }));
    const [isNewMenuModalOpen, setIsNewMenuModalOpen] = useState(false);

    const toggleNewMenuModal = () => {
        setIsNewMenuModalOpen(!isNewMenuModalOpen);
    }

    const fetchData = async (targetOffset) => {
        try {
            if (currentlyFetching)
                return;

            if (!stopFetching) {
                currentlyFetching = true;

                if (targetOffset == 0)
                    setMenus([]);

                setLoading(true);

                const response = await fetch(AppConfig.URL + '/Menu/Index/?Search=' + search + "&Active=" + filterActive, {
                        method: 'GET',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': auth.token
                        },
                    }
                );

                const data = await response.json();

                if (data.menus.length < limit) {
                    stopFetching = true;
                    setHideLoadButton(true);
                }

                let allMenus = [...menus];

                if (targetOffset == 0) {
                    allMenus = data.menus;
                } else {
                    allMenus = allMenus.concat(data.food);
                }

                setLoading(false);
                setMenus(allMenus);
                offset = targetOffset + limit;
            }
        } catch (error) {
            console.log(error);

            setLoading(false);
        }
    }

    useEffect(() => {
        if (timerRef.current)
            clearTimeout(timerRef.current);

        // @ts-ignore
        timerRef.current = setTimeout(async () => {
            fetchData(0);
        }, 250);
    }, [search])

    useEffect(() => {
        fetchData(0);
    }, [filterActive])

    useEffect(() => {
        fetchData(0);
    }, [])

    return <View style={{}}>
        <View
            style={{marginBottom: 15, flexDirection: 'row', justifyContent: 'space-between'}}
        >
            <h1>
                {TMenuScreen[AppConfig.lang].MENUS}
            </h1>
            {auth.sub && (
                auth.sub.code === AppConfig.SUB_STANDARD
                ||
                auth.sub.code === AppConfig.SUB_PREMIUM
            ) ?
                <ThemeButton
                    text={TMenuScreen[AppConfig.lang].NEW_MENU}
                    onPress={toggleNewMenuModal}
                />
                :
                null
            }
        </View>
        <View
            className={'card-desktop'}
        >
            <View
                className={'card-body'}
                style={{
                    paddingTop: 0, paddingBottom: 0
                }}
            >
                <View className="row hide-mobile">
                    <View className="col-8 col-lg-9 th">
                        <CCText style={{fontWeight: 'bold'}}>
                            {TMenuScreen[AppConfig.lang].NAME}
                        </CCText>
                    </View>
                    <View className="col-4 col-lg-3 th" style={{}}>

                    </View>
                </View>
                <View>
                    {menus.map(item => <MenuItem
                        key={item.men_id}
                        item={item}
                        Auth={auth}
                    />)}
                    <View>
                        {loading ?
                            <ActivityIndicator
                                style={{
                                    marginTop: 15,
                                    marginBottom: 30,
                                    flexDirection: 'row',
                                    justifyContent: 'center'
                                }}
                            />
                            :
                            !hideLoadButton ?
                                <ThemeButton
                                    text={TMenuScreen[AppConfig.lang].LOAD_MORE}
                                    onPress={() => {
                                        fetchData(offset)
                                    }}
                                    style={{
                                        marginTop: 15,
                                        marginBottom: 30,
                                        flexDirection: 'row',
                                        justifyContent: 'center'
                                    }}
                                />
                                :
                                null
                        }
                    </View>
                    <FormModal
                        title={TMenuScreen[AppConfig.lang].NEW_MENU}
                        form={form}
                        isOpen={isNewMenuModalOpen}
                        toggle={toggleNewMenuModal}
                        confirmFunction={async () => {
                            const controls = {...form.controls}

                            if (form.isValidForm) {
                                let formData = {};

                                formData["men_name"] = controls['men_name'].value;

                                const response = await fetch(AppConfig.URL + "/Menu/Create", {
                                    method: 'POST',
                                    headers: {
                                        'Accept': 'application/json',
                                        'Content-Type': 'application/json',
                                        'Authorization': auth.token
                                    },
                                    body: JSON.stringify(formData)
                                });

                                const json = await response.json();

                                if (json.success) {
                                    controls['men_name'].value = '';

                                    setForm(new ChocoForm(controls))

                                    const updatedMenus = [...menus];

                                    updatedMenus.push(json.menu)

                                    setMenus(updatedMenus)
                                    toggleNewMenuModal();
                                }
                            } else {
                                toggleNewMenuModal();
                            }
                        }}
                        cancelText={TMenuScreen[AppConfig.lang].CANCEL}
                        confirmText={TMenuScreen[AppConfig.lang].SAVE}
                        onFormChange={(updatedForm) => {
                            setForm(updatedForm);
                        }}
                    />
                </View>
            </View>
        </View>
    </View>
}

export default MenuScreen;